/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import { connect } from "react-redux";

//table imports
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";

//icons
import Delete from "@mui/icons-material/Delete";

import { withTranslation } from "react-i18next";

import { Grid } from "@mui/material";
import Input from "../../../component/inputpm";
import { Tooltip } from "@mui/material";
import { IconButton, FormControl, Select } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import classes from "../createPackage/createPackage.module.css";
import classesDiv from "../packagedSolution/createPackage.module.css";
import Button from "../../../component/button";
import { Checkbox } from "@mui/material";
import { MenuItem } from "@mui/material";
import { ListItemText } from "@mui/material";
import OriginalInput from "@mui/material/Input";
import Card from "@mui/material/Card";
import { DeleteIconNew } from "../../../component/icons/icons";
import TableContainer from "@mui/material/TableContainer";

const CustomAttributes = (props) => {
  useEffect(() => { });
  const t = props.t;
  const setInputType = (val) => {
    if (val === "string") {
      return "text";
    } else if (val === "number" || val === "decimal") {
      return "number";
    } else if (val === "email") {
      return "email";
    } else if (val === "date") {
      return "date";
    } else if (val === "datetime") {
      return "datetime-local";
    } else {
      return "text";
    }
  };
  const checkNoAttributesConfigured = (rows) => {
    if (rows && rows.length > 0) {
      var count = 0;
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].delete) {
          count++;
        }
      }
      if (count === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  return (
    <React.Fragment>
      <div>
        <Grid container spacing={2}>
          {(!props.mode || props.mode !== "readonly") && (
            <>
              {props.readonlyMode ? (
                ""
              ) : (
                <>
                  <Grid
                    item
                    size={{
                      xs: 10,
                      md: 6,
                    }}
                  >
                    <Autocomplete
                      options={props.list}
                      onChange={(event, value) => props.selectAttribute(value)}
                      size="small"
                      value={props.tempSelectedAttribute}
                      // getOptionDisabled={(option) => option.selected}
                      getOptionLabel={(option) => option.attrName}
                      // disabled={props.mode === 'edit'}
                      classes={{
                        option: classes.autoCompleteOption,
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("SELECT_CUSTOM_ATTRIBUTES")}
                          variant="outlined"
                        />
                      )}
                      disabled={props.disableInputFields}
                    />
                  </Grid>
                  <Grid
                    item
                    style={{ alignContent: "center" }}
                    size={{
                      xs: 2,
                      md: 6,
                    }}
                  >
                    {!props.disableInputFields && (
                      <Button onClick={props.addAttribute}>{t("ADD")}</Button>
                    )}
                  </Grid>
                </>
              )}
            </>
          )}
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <Card
              variant="outlined"
              style={{ borderRadius: "8px", marginBottom: "40px" }}
            >
              <TableContainer>
                <Table className="newGlobalTable roundCorners">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "30%" }}>
                        {t("ATTRIBUTE_NAME")}
                      </TableCell>
                      <TableCell style={{ width: "60%" }}>
                        {t("ATTRIBUTE_VALUE")}
                      </TableCell>
                      {(!props.mode || props.mode !== "readonly") && (
                        <TableCell style={{ width: "10%" }}>
                          {t("ACTION")}
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data &&
                      props.data.length > 0 &&
                      props.data.map(
                        (item, i) =>
                          !item.delete && (
                            <TableRow key={i}>
                              <TableCell>
                                {item.attrName}
                                {item.required ? "*" : ""}
                              </TableCell>
                              <TableCell valign="center">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {item.valueType === "boolean" ? (
                                    <>
                                      <Checkbox
                                        value={item.attrValue}
                                        checked={item.attrValue}
                                        onChange={props.onChangeAttribute}
                                        color="primary"
                                        name={item.attrName}
                                        disabled={
                                          props.readonlyMode ||
                                          props.disableInputFields
                                        }
                                      />
                                      <span style={{ marginLeft: "6px" }}>
                                        {item.attrValue ? "Yes" : "No"}
                                      </span>
                                    </>
                                  ) : item.valueType === "collection" ? (
                                    <>
                                      <FormControl
                                        variant="outlined"
                                        size={"small"}
                                        style={{ width: "400px" }}
                                        className={"customeSelectLabel"}
                                      >
                                        <Select
                                          value={item.attrValue}
                                          native
                                          onChange={props.onChangeAttribute}
                                          inputProps={{
                                            name: item.attrName,
                                            id: item.attrName,
                                          }}
                                          disabled={
                                            props.readonlyMode ||
                                            props.disableInputFields
                                          }
                                        >
                                          <option value=""></option>
                                          {item.options &&
                                            item.options.map((option, e) => (
                                              <option key={e} value={option.id}>
                                                {option.value}
                                              </option>
                                            ))}
                                        </Select>
                                      </FormControl>
                                    </>
                                  ) : (
                                    // <>
                                    //   <Input
                                    //     value={item.attrValue}
                                    //     name={item.attrName}
                                    //     onChange={props.onChangeAttribute}
                                    //     type={setInputType(item.valueType)}
                                    //     style={{ width: "400px" }}
                                    //     disabled={
                                    //       props.readonlyMode ||
                                    //       props.disableInputFieldss
                                    //     }
                                    //   />{" "}
                                    //   (
                                    //   {item.valueType === "number"
                                    //     ? "Number"
                                    //     : "Text"}
                                    //   )
                                    // </>
                                    <>
                                      <Input
                                        value={item.attrValue}
                                        name={item.attrName}
                                        onChange={props.onChangeAttribute}
                                        type={setInputType(item.valueType)}
                                        maxLength={
                                          item.attrName?.includes("quantityValidation") ? 255 : undefined
                                        }
                                        style={{ width: "400px" }}
                                        disabled={
                                          props.readonlyMode ||
                                          props.disableInputFieldss
                                        }
                                      />{" "}
                                      ({item.valueType === "number" ? "Number" : "Text"})

                                      {item.attrName?.includes("quantityValidation") && (
                                        <div style={{ fontSize: "12px", color: "#666", marginTop: "4px", marginLeft: '10px' }}>
                                          Remaining characters: {255 - (item.attrValue?.length || 0)}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </TableCell>
                              {(!props.mode || props.mode !== "readonly") &&
                                !props.disableInputFields && (
                                  <TableCell>
                                    {!item.required && (
                                      <>
                                        {props.readonlyMode ||
                                          props.disableInputFields ? (
                                          ""
                                        ) : (
                                          <Tooltip title={t("DELETE")}>
                                            {/* <Delete onClick={() => props.removeAttribute(item)} /> */}
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={() =>
                                                props.removeAttribute(item)
                                              }
                                            >
                                              <DeleteIconNew />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                )}
                            </TableRow>
                          ),
                      )}
                    {checkNoAttributesConfigured(props.data) && (
                      <TableRow>
                        <TableCell align="center" colSpan={3}>
                          {t("NO_CUSTOM_ATTRIBUTES_ADDED")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(CustomAttributes),
);
